module.exports = __webpack_public_path__ + "assets/images/plannerCrop-08d092d3d1ab8172281f62c2d8e9970a.gif";